import {
  ANCHOR_PALETTE,
  WARM_LIGHT,
} from "../../../../api/src/shared/domain/cover-palette";
import { seededUnit } from "../../../../api/src/shared/seeded-hash";

/** One anchor of the cover palette, drawn from the seed. */
function anchorHex(seed: string, axis: string): string {
  const index = Math.floor(seededUnit(seed, axis) * ANCHOR_PALETTE.length);
  const anchor = ANCHOR_PALETTE[index];
  if (anchor === undefined)
    throw new Error(`should not happen: anchor ${index} is in the palette`);
  return anchor.hex;
}

/**
 * The backdrop of a collection with no image: two anchors of the AI covers'
 * palette and their warm light, laid out from the collection's id. Blurred, it
 * reads as one of those covers, and it does not move when the collection is
 * renamed.
 */
export function collectionBackdrop(collectionId: string): string {
  const percent = (axis: string): number =>
    Math.round(seededUnit(collectionId, axis) * 100);
  const angle = Math.round(seededUnit(collectionId, "angle") * 360);
  return [
    `radial-gradient(ellipse at ${percent("light-x")}% ${percent("light-y")}%, ${WARM_LIGHT.hex} 0%, transparent 55%)`,
    `radial-gradient(ellipse at ${percent("second-x")}% ${percent("second-y")}%, ${anchorHex(collectionId, "second")} 0%, transparent 65%)`,
    `linear-gradient(${angle}deg, ${anchorHex(collectionId, "anchor")}, ${WARM_LIGHT.hex})`,
  ].join(", ");
}
